export const CONSENT_MAPPING = {
  none: 0,
  functional: 1,
  all: 2,
};
